<template>
    <div>
        <span>
            <g-tag :theme="color">{{ label }}</g-tag>
            <g-tag v-if="isPaidToAgent">Paid to Agent</g-tag>
        </span>
    </div>
</template>

<script>
    import capitalize from 'lodash-es/capitalize';
    import { computed } from 'vue-demi';
    import {
        PAYOUT_STATUS_LABELS,
        PAYOUT_STATUS_COLORS,
        PAYOUT_STATUS_VOIDED,
        PAYOUT_STATUS_COMPLETED,
        PAYOUT_STATUS_OWED,
        PAYOUT_STATUS_PENDING
    } from '../../../../../app-v2/constants/payouts';

    export default {
        name: 'PayoutStatus',
        props: {
            payout: {
                type: Object,
                default: null
            },
            isConversion: {
                type: Boolean,
                default: false
            },
            isPaidToAgent: {
                type: Boolean,
                default: false
            }
        },

        setup(props) {
            const getPaymentStatus = () => {
                let status = props.payout.status;

                if (!status) {
                    status = PAYOUT_STATUS_OWED;
                    if (props.payout.sent_at) {
                        status = PAYOUT_STATUS_PENDING;
                    }
                }

                return status;
            };

            const getConversionStatus = () => {
                let status = PAYOUT_STATUS_PENDING;
                if (props.payout.is_voided) {
                    status = PAYOUT_STATUS_VOIDED;
                } else if (props.payout.is_paid) {
                    status = PAYOUT_STATUS_COMPLETED;
                }
                return status;
            };

            const getStatus = () => {
                return props.isConversion ? getConversionStatus() : getPaymentStatus();
            };

            const conversionIsVoided = () => {
                return props.isConversion && props.payout.is_voided;
            };

            const conversionVoidedReason = () => {
                return props.payout.void_reason ? capitalize(props.payout.void_reason) : '';
            };

            const label = computed(() => {
                return conversionIsVoided()
                    ? PAYOUT_STATUS_LABELS[getStatus()] + ': ' + conversionVoidedReason()
                    : PAYOUT_STATUS_LABELS[getStatus()];
            });

            const color = computed(() => {
                return PAYOUT_STATUS_COLORS[getStatus()];
            });

            return {
                label,
                color
            };
        }
    };
</script>
